export default __webpack_public_path__ + "static/media/Eb6.5816a5c6.mp3";